var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#check-fill';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-check-fill';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?check-fill#check-fill';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?check-fill#view-check-fill';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 80 80',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };